import { render } from "./LoadingVetReviewPreview.vue?vue&type=template&id=a557bfa2&ts=true"
import script from "./LoadingVetReviewPreview.vue?vue&type=script&lang=ts"
export * from "./LoadingVetReviewPreview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__